const customCategoryNames = {
  sv: {
    26: `Landfiske`,
    73: `Butik`,
    74: `Båtuthyrning`,
  },
}

module.exports = { customCategoryNames }
